/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Dra för att ändra storlek på panelen',
  command_intelligence_close_aria: 'Stäng assistent',
  command_intelligence_send_aria: 'Skicka meddelande',
  command_intelligence_stop_aria: 'Stoppa svar',
  command_intelligence_composer_input_aria: 'Meddelande till Command Intelligence',
  command_intelligence_drawer_more_options: 'Fler alternativ',
  command_intelligence_dock_position: 'Dockningsposition',
  command_intelligence_dock_left: 'Vänster',
  command_intelligence_dock_right: 'Höger',
  command_intelligence_dock_top: 'Överst',
  command_intelligence_dock_bottom: 'Nederst',
  command_intelligence_panel_layout: 'Panellayout',
  command_intelligence_panel_layout_overlap: 'Överlappa innehåll',
  command_intelligence_panel_layout_push: 'Skjut innehåll',
  command_intelligence_panel_auto_hide_overlap: 'Dölj automatiskt vid klick utanför',
  command_intelligence_session_reset: 'Återställ konversation',
  command_intelligence_try_one_of_these: 'Prova något av dessa',
  command_intelligence_attach_hint: 'Bifoga kontextobjekt för att börja ställa frågor.',
  command_intelligence_welcome_subhead: 'Ställ en fråga för att komma igång.',
  command_intelligence_attach_modal_title: 'Bifoga kontext',
  command_intelligence_attach_modal_subtitle: 'Välj från objekt i den här vyn. Redan bifogade objekt är utgråade.',
  command_intelligence_attach_modal_search_placeholder: 'Sök…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# objekt tillgängligt} other {# objekt tillgängliga}} · {selected} valda',
  command_intelligence_attach_modal_empty: 'Inget tillgängligt att bifoga',
  command_intelligence_attach_modal_no_results: 'Inga objekt matchar din sökning',
  command_intelligence_context_bar_attached_section: 'Bifogade ({count})',
  command_intelligence_context_bar_clear_attached: 'Rensa',
  command_intelligence_context_bar_add: 'Bifoga kontext',
  command_intelligence_placeholder_ready: 'Ställ en fråga…',
  command_intelligence_placeholder_attach: 'Bifoga kontext för att ställa en fråga…',
  command_intelligence_composer_submit_hint: 'Enter för att skicka · Skift+Enter för ny rad',
  command_intelligence_composer_stop_hint: 'Stoppa · utkast till nästa meddelande medan du väntar',
  command_intelligence_response_stopped: 'Svar stoppat',
  command_intelligence_generation_in_progress: 'Arbetar med din fråga',
  command_intelligence_generation_trace_title: 'Utförda steg',
  command_intelligence_generation_trace_toggle: 'Visa steg',
  command_intelligence_generation_trace_summary: '{completed} av {total} steg slutförda',
  command_intelligence_generation_trace_summary_generic: 'Genereringssteg',
  command_intelligence_generation_tool_count: '{count, plural, one {# verktyg} other {# verktyg}}',
  command_intelligence_generation_turn_label: 'Tur {turn} av {total}',
  command_intelligence_generation_turn_completed: 'Tur {turn} av {total} slutförd',
  command_intelligence_generation_turn_completed_elapsed: 'Tur {turn} av {total} slutförd ({seconds}s förflutna)',
  command_intelligence_generation_turn_completed_with_tools: 'Tur {turn} av {total} slutförd – använde {tools}',
  command_intelligence_generation_tools_used: 'Använde {tools}',
  command_intelligence_reasoning_thinking: 'Tänker…',
  command_intelligence_reasoning_thought_for_seconds: 'Tänkte i {seconds} sekunder',
  command_intelligence_reasoning_waiting: 'Arbetar med din fråga…',
  command_intelligence_attach_modal_done: 'Klar',
  command_intelligence_attach_modal_attached_badge: 'bifogad',
  command_intelligence_attach_modal_attach: 'Bifoga',
  command_intelligence_attach_modal_attach_count: 'Bifoga ({count})',
  command_intelligence_attach_modal_close_aria: 'Stäng väljare',
  command_intelligence_session_limit_context: 'Kontextgräns nådd. Återställ konversationen för att fortsätta.',
  command_intelligence_session_limit_prompt: 'Meddelandegräns nådd. Återställ konversationen för att fortsätta.',
  command_intelligence_suggested_followups: 'Föreslagna uppföljningar',
  command_intelligence_credit_warning_line: '{pct}% av månatliga AI-krediter för {scope} använda',
  command_intelligence_tooltip_prompts: '{count} av {max} meddelanden ({pct}%)',
  command_intelligence_tooltip_context: '{used} av {max} kontexttokens ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Kontextanvändning visas efter första svaret',
  command_intelligence_credits_loading: 'Laddar krediter…',
  command_intelligence_credits_unavailable: 'Krediter otillgängliga',
  command_intelligence_credits_tooltip: 'Månatliga AI-krediter för {monthKey}',
  command_intelligence_credits_tooltip_short: 'Månatliga AI-krediter',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Enhet',
  command_intelligence_credits_used_of_cap: '{used} av {cap} krediter',
  command_intelligence_credits_used_no_cap: '{used} krediter använda',
  command_intelligence_credits_monthly_title: 'Månatliga AI-krediter',
  command_intelligence_compare_aria: 'Jämför agenter',
  command_intelligence_compare_tooltip: 'Kör samma fråga mot flera agentprofiler',
  command_intelligence_compare_cancelled: 'Jämförelse avbruten',
  command_intelligence_compare_branch_failed: 'Jämförelsegren misslyckades',
  command_intelligence_compare_title: 'Agentjämförelse',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} in / {outTok} ut · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Bra svar',
  command_intelligence_feedback_bad_response: 'Dåligt svar',
  command_intelligence_feedback_dialog_title: 'Ge feedback',
  command_intelligence_feedback_dialog_body:
    'Hjälp oss förbättra genom att ge feedback på det här svaret. Din feedback skickas till vårt driftteam.',
  command_intelligence_feedback_response_label: 'Svar',
  command_intelligence_feedback_input_label: 'Din feedback (valfritt)',
  command_intelligence_feedback_input_placeholder: 'Vad var fel eller oanvändbart med det här svaret?',
  command_intelligence_feedback_submit: 'Skicka feedback',
  command_intelligence_feedback_submit_error: 'Kunde inte skicka feedback. Försök igen.',
  command_intelligence_feedback_question_understanding: 'Förstod agenten vad du ville?',
  command_intelligence_feedback_question_readability: 'Var svaret lätt att läsa och använda?',
  command_intelligence_feedback_section_understanding: 'Förståelse',
  command_intelligence_feedback_section_readability: 'Läsbarhet',
  command_intelligence_feedback_choice_none: 'Ingen',
  command_intelligence_feedback_choice_misunderstood_task: 'Missförstod uppgift',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignorerade begränsning',
  command_intelligence_feedback_choice_wrong_scope: 'Fel omfattning',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visuellt svår att läsa',
  command_intelligence_feedback_choice_wrote_too_much: 'Skrev för mycket',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Förklaring inte tillförlitlig',
  command_intelligence_copy_aria: 'Kopiera till urklipp',
  command_intelligence_error_missing_invoke_permission:
    'Du har inte behörighet att använda Command Intelligence för den här agenten. Be din administratör att bevilja nödvändiga Intelligence-behörigheter (till exempel analyst).',
  command_intelligence_access_denied_title: 'Åtkomst krävs',
  command_intelligence_error_session_expired: 'Din session har gått ut. Uppdatera sidan och logga in igen.',
};
